import { memo, useEffect } from 'react'
import { useSubscriptionDialog } from '../../providers/SubscriptionDialogProvider'

const SubscriptionPage = () => {
  const { openSubscriptionDialog, closeSubscriptionDialog } = useSubscriptionDialog()
  useEffect(() => {
    openSubscriptionDialog()
    return () => {
      closeSubscriptionDialog()
    }
  })
  return null
}

export default memo(SubscriptionPage)
